import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

export default function App() {
  const isAuthenticated = !!localStorage.getItem("user");

  return (
    <BrowserRouter>
      <Routes>
        {/* Redirections par défaut */}
        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />

        {/* Routes protégées */}
        <Route
          path="/app/*"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        />

        {/* Routes publiques */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );

  // ###########################################################

  function PrivateRoute({ children }) {
    return isAuthenticated ? children : <Navigate to="/login" replace />;
  }

  function PublicRoute({ children }) {
    return isAuthenticated ? <Navigate to="/app/dashboard" replace /> : children;
  }
}